import { useMutation, useQueryClient } from "@tanstack/react-query";
import { forceDeleteAllAcademicTerms as apiForceDeleteAll } from "../../api/apiAcademicTerms";
import { useSnackbar } from "notistack";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useForceDeleteAllAcademicTerms() {
    const queryClient = useQueryClient();
    const { enqueueSnackbar } = useSnackbar();

    const { mutate: forceDeleteAllAcademicTerms, isPending: isForceDelete } = useMutation({
        mutationFn: (req) => apiForceDeleteAll(req),
        onSuccess: (response) => {
            enqueueSnackbar(response.message, { variant: "success" });
            queryClient.invalidateQueries({ queryKey: ["academicTerms"] });
        },
        onError: (err) => {
            const msg = getErrorMessageFromAxiosError(err, "Something went wrong!");
            enqueueSnackbar(msg, { variant: "error" });
        },
    });

    return { forceDeleteAllAcademicTerms, isForceDelete };
}
